import { useUserRoles } from 'src/features/auth/useUserRoles';

// Wider than useCanManageDeveloperPlatform: these roles get the pitch or a
// note about who to ask. Mirrors DEVELOPER_PLATFORM_VIEW_ROLES. Associates are
// left out because RequireAuth shows them AssociateNotice instead of the app,
// as are the ride ordering portal roles and restricted support, which have no
// route here.
export function useCanViewDeveloperPlatform() {
  const { isOwner, isAdmin, isBambi, isDispatcher } = useUserRoles();

  return isOwner || isAdmin || isBambi || isDispatcher;
}
